import React, { useMemo } from "react";
import { isoWebPageURL } from "tsi-common-react/src/models/nominals";

import { reverse } from "@reactivated";

import { check } from "../../../models/utils";
import { usePageURL } from "../../../utils/urls";
import { ModularConfiguratorOptionSet } from "../models";
import { IModularConfiguratorOptionSet } from "../models.interfaces";
import { Configurator, IOwnProps as IConfiguratorProps } from "./Configurator";

interface IProps {
    optionSetJSON: string;
    passthroughProps?: Partial<IConfiguratorProps>;
}

export const ModularConfigurator = (props: IProps): React.ReactNode => {
    const optionSet = useMemo((): IModularConfiguratorOptionSet => {
        const data = check(
            ModularConfiguratorOptionSet.decode(
                JSON.parse(props.optionSetJSON),
            ),
        );
        return data;
    }, [props.optionSetJSON]);

    const financeLink = usePageURL("finance_link");
    const homeLink = usePageURL("home");
    const financingLink = financeLink || homeLink;

    return (
        <Configurator
            optionSet={optionSet}
            financingLink={financingLink}
            basketLink={isoWebPageURL.wrap(reverse("basket:summary"))}
            favoritesLink={isoWebPageURL.wrap(reverse("basket:summary"))}
            configureGiftsLink={isoWebPageURL.wrap(
                reverse("basket:configure-gifts"),
            )}
            {...props.passthroughProps}
        />
    );
};
